export const MlIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="25"
    height="25">
    <circle cx="16" cy="16" r="6" fill="none" stroke="black" strokeWidth="2" />
    <circle cx="48" cy="16" r="6" fill="none" stroke="black" strokeWidth="2" />
    <circle cx="16" cy="48" r="6" fill="none" stroke="black" strokeWidth="2" />
    <circle cx="48" cy="48" r="6" fill="none" stroke="black" strokeWidth="2" />

    <line x1="16" y1="16" x2="48" y2="16" stroke="black" strokeWidth="2" />
    <line x1="16" y1="16" x2="16" y2="48" stroke="black" strokeWidth="2" />
    <line x1="48" y1="16" x2="48" y2="48" stroke="black" strokeWidth="2" />
    <line x1="16" y1="48" x2="48" y2="48" stroke="black" strokeWidth="2" />

    <line
      x1="16"
      y1="16"
      x2="48"
      y2="48"
      stroke="black"
      strokeWidth="2"
      stroke-dasharray="4"
    />
    <line
      x1="48"
      y1="16"
      x2="16"
      y2="48"
      stroke="black"
      strokeWidth="2"
      stroke-dasharray="4"
    />
  </svg>
);
